<script setup lang="ts">
import { computed } from "vue";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { ColorsTypeEnum } from "~/utils/enums/colores.enums";
import { tagFamilyColorType } from "~/utils/color/colorMapping";

const props = defineProps<{
  tag?: {
    value: string;
    type: ColorsTypeEnum | string;
    logo?: string | null;
    icon?: string | null;
    color?: string;
    strikethrough?: boolean;
  };
  /** 12px text, for pills inside dense cards. */
  small?: boolean;
  /** Leading dot that marks a business state: render statuses with StatusTag, which sets it. */
  dot?: boolean;
}>();

const typeClass = computed(() => `tag_${tagFamilyColorType(props.tag?.color) ?? props.tag?.type}`);
</script>

<template>
  <div class="tag_main w-full max-w-max" :class="typeClass">
    <span v-if="dot" class="size-1.5 shrink-0 mr-1.5 rounded-full bg-current" aria-hidden="true"></span>
    <SvgIcon
      v-if="tag?.logo"
      class="cursor-pointer w-[20px] h-[20px] pr-[4px] justify-center"
      :name="tag?.logo"
    ></SvgIcon>
    <SvgIcon
      v-else-if="tag?.icon && !tag?.icon?.includes('/')"
      class="cursor-pointer w-[20px] h-[20px] pr-[4px] justify-center"
      :name="tag?.icon"
    ></SvgIcon>
    <img v-else-if="tag?.icon" class="cursor-pointer w-[20px] h-[20px] pr-[4px] justify-center" :src="tag?.icon" />
    <!-- Small sizes the line box, not just the span: a smaller span keeps the surrounding font's line height. -->
    <div class="item_field" :class="{ small_regular: small }">
      <span class="text-center truncate" :class="{ body_regular: !small, 'line-through': tag?.strikethrough }">{{
        tag?.value
      }}</span>
    </div>
  </div>
</template>

<style scoped>
.tag_main {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
}

.item_field {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
